import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import { SiteDocument } from '../Site/queryBuilder';
import {
  BorerShiftCommentTypeDocument,
  borerShiftCommentTypePullQueryBuilder,
} from './queryBuilder';

export function borerShiftCommentTypeFamilyMember(
  configBuilder: ConfigBuilder,
  sites: FamilyMember<SiteDocument>,
): FamilyMember<BorerShiftCommentTypeDocument> {
  const syncConfig = configBuilder<BorerShiftCommentTypeDocument>(
    RxdbCollectionNameV2.BORER_SHIFT_COMMENT_TYPE,
  );
  doNotAutoSync(syncConfig);

  pull(syncConfig, borerShiftCommentTypePullQueryBuilder);

  const replicationState = replicate(syncConfig);
  // Legacy had the syncInterval set to LiveInterval.MINUTES_15.
  return create(RxdbCollectionNameV2.BORER_SHIFT_COMMENT_TYPE, replicationState, [sites]);
}
